<span class="cell-text">
  <span
    class="cell-value"
    [nbTooltip]="clean"
    [nbTooltipDisabled]="!clean"
    nbTooltipPlacement="top"
  >{{ display }}</span>
  <span
    *ngIf="suffix"
    class="cell-suffix"
    [nbTooltip]="suffixTooltip || ''"
    [nbTooltipDisabled]="!suffixTooltip"
  >{{ suffix }}</span>
</span>
